import { createFileRoute } from "@tanstack/react-router"

import { VehicleDetail } from "@/trips/components/mileage/vehicle-detail"

export const Route = createFileRoute("/_app-shell/vehicles/$id")({
  head: () => ({ meta: [{ title: "Vehicle - Kestly" }] }),
  component: function VehicleRoute() {
    const { id } = Route.useParams()
    return <VehicleDetail vehicleId={id} />
  },
})
